/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carousel_NextInputs */

const en_carousel_next = /** @type {(inputs: Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next slide`)
};

const ar_carousel_next = /** @type {(inputs: Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الشريحة التالية`)
};

const bn_carousel_next = /** @type {(inputs: Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পরের স্লাইড`)
};

const de_carousel_next = /** @type {(inputs: Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächste Folie`)
};

const es_carousel_next = /** @type {(inputs: Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiente diapositiva`)
};

const fr_carousel_next = /** @type {(inputs: Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diapositive suivante`)
};

const pt_carousel_next = /** @type {(inputs: Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo slide`)
};

const zh_carousel_next = /** @type {(inputs: Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一张幻灯片`)
};

const tr_carousel_next = /** @type {(inputs: Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonraki slayt`)
};

const ru_carousel_next = /** @type {(inputs: Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следующий слайд`)
};

const pl_carousel_next = /** @type {(inputs: Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Następny slajd`)
};

/**
* | output |
* | --- |
* | "Next slide" |
*
* @param {Carousel_NextInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const carousel_next = /** @type {((inputs?: Carousel_NextInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carousel_NextInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_carousel_next(inputs)
	if (locale === "bn") return bn_carousel_next(inputs)
	if (locale === "de") return de_carousel_next(inputs)
	if (locale === "es") return es_carousel_next(inputs)
	if (locale === "fr") return fr_carousel_next(inputs)
	if (locale === "pt") return pt_carousel_next(inputs)
	if (locale === "zh") return zh_carousel_next(inputs)
	if (locale === "tr") return tr_carousel_next(inputs)
	if (locale === "ru") return ru_carousel_next(inputs)
	if (locale === "pl") return pl_carousel_next(inputs)
	return en_carousel_next(inputs)
});